// import React, { useState, useEffect } from 'react';
// import { useNavigate, useParams } from 'react-router-dom';
// import axios from 'axios';
// import { Base_Url } from '../config';

// const ProfileForm = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const isEditing = !!id;

//   const [formData, setFormData] = useState({
//     name: '',
//     userid: '',
//     designation: '',
//     // show_in_display: false,
//     // isretired: false,
//     summary: '',
//     bio: '',
//     cv_and_specialization: '',
//     teaching_and_research: '',
//     others: '',
//     academics: '',
//     weblink: '',      // New field
//     email: '',        // New field
//     phone: '',        // New field
//     image: null,
//       order: '0' 
//   });
//   const [imagePreview, setImagePreview] = useState('');
//   const [isLoading, setIsLoading] = useState(false);

//   useEffect(() => {
//     if (isEditing) {
//       fetchProfile();
//     }
//   }, [id]);

//  const fetchProfile = async () => {
//   try {
//     const response = await axios.get(`${Base_Url}/profile/${id}`);
//     const profileData = response.data;
//     setFormData({
//       name: profileData.name || '',
//       userid: profileData.userid || '',
//       designation: profileData.designation || '',
//       // show_in_display: profileData.show_in_display === 1 || false,
//       // isretired: profileData.isretired === 1 || false,
//       summary: profileData.summary || '',
//       bio: profileData.bio || '',
//       cv_and_specialization: profileData.cv_and_specialization || '',
//       teaching_and_research: profileData.teaching_and_research || '',
//       others: profileData.others || '',
//       academics: profileData.academics || '',
//       weblink: profileData.weblink || '',      // New field
//       email: profileData.email || '',          // New field
//       phone: profileData.phone || '',          // New field
//       order: profileData.order || '0'          // ✅ YEH ADD KARO - order field
//     });
//     if (profileData.image_path) {
//       setImagePreview(`${Base_Url}/${profileData.image_path}`);
//     }
//   } catch (error) {
//     console.error('Error fetching profile:', error);
//     alert('Error loading profile data');
//   }
// };

//   const handleInputChange = (e) => {
//     const { name, value, type, checked, files } = e.target;
    
//     if (type === 'file') {
//       setFormData(prev => ({ ...prev, image: files[0] }));
//       setImagePreview(URL.createObjectURL(files[0]));
//     } else if (type === 'checkbox') {
//       setFormData(prev => ({ ...prev, [name]: checked }));
//     } else {
//       setFormData(prev => ({ ...prev, [name]: value }));
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setIsLoading(true);

//     try {
//       const formDataToSend = new FormData();
//       Object.keys(formData).forEach(key => {
//         if (key === 'image' && formData[key]) {
//           formDataToSend.append('image', formData[key]);
//         } else {
//           formDataToSend.append(key, formData[key]);
//         }
//       });

//       if (isEditing) {
//         await axios.put(`${Base_Url}/profile/${id}`, formDataToSend, {
//           headers: { 'Content-Type': 'multipart/form-data' }
//         });
//       } else {
//         await axios.post(`${Base_Url}/profile`, formDataToSend, {
//           headers: { 'Content-Type': 'multipart/form-data' }
//         });
//       }

//       navigate('/');
//     } catch (error) {
//       console.error('Error saving profile:', error);
//       alert('Error saving profile. Please try again.');
//     } finally {
//       setIsLoading(false);
//     }
//   };


//   // console.log(formData)
//   return (
//     <div className="container mt-4">
//       <div className="card">
//         <div className="card-header bg-white">
//           <div className="d-flex justify-content-between align-items-center">
//             <h5 className="card-title mb-0">
//               {isEditing ? 'Edit Profile' : 'Add New Profile'}
//             </h5>
//           </div>
//         </div>
//         <div className="card-body">
//           <form onSubmit={handleSubmit}>
//             <div className="row">
//               {/* Image Upload Section */}
//               <div className="col-md-3 mb-3">
//                 <div className="text-center">
//                   <div className="mb-3">
//                     {(imagePreview || formData.image) && (
//                       <img
//                         src={imagePreview}
//                         alt="Profile Preview"
//                         className="rounded-circle mb-3"
//                         style={{ width: '150px', height: '150px', objectFit: 'cover' }}
//                       />
//                     )}
//                   </div>
//                   <div className="mb-3">
//                     <label className="btn btn-outline-primary btn-sm">
//                       Choose Image
//                       <input
//                         type="file"
//                         className="d-none"
//                         name="image"
//                         onChange={handleInputChange}
//                         accept="image/*"
//                       />
//                     </label>
//                   </div>
//                 </div>
//               </div>

//               {/* Form Fields Section */}
//               <div className="col-md-9">
//                 <div className="row">
//                   {/* Basic Information */}
//                   <div className="col-md-6 mb-3">
//                     <label className="form-label">Name</label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       name="name"
//                       value={formData.name}
//                       onChange={handleInputChange}
//                       required
//                     />
//                   </div>

//                   <div className="col-md-6 mb-3">
//                     <label className="form-label">User ID</label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       name="userid"
//                       value={formData.userid}
//                       onChange={handleInputChange}
//                       required
//                     />
//                   </div>

//                   <div className="col-md-12 mb-3">
//                     <label className="form-label">Designation</label>
//                     <input
//                       type="text"
//                       className="form-control"
//                       name="designation"
//                       value={formData.designation}
//                       onChange={handleInputChange}
//                       required
//                     />
//                   </div>

//                   {/* Contact Information */}
//                   <div className="col-md-4 mb-3">
//                     <label className="form-label">Email</label>
//                     <input
//                       type="email"
//                       className="form-control"
//                       name="email"
//                       value={formData.email}
//                       onChange={handleInputChange}
//                     />
//                   </div>

//                   <div className="col-md-4 mb-3">
//                     <label className="form-label">Phone</label>
//                     <input
//                       type="tel"
//                       className="form-control"
//                       name="phone"
//                       value={formData.phone}
//                       onChange={handleInputChange}
//                     />
//                   </div>

//                   <div className="col-md-4 mb-3">
//                     <label className="form-label">Website</label>
//                     <input
//                       type="url"
//                       className="form-control"
//                       name="weblink"
//                       value={formData.weblink}
//                       onChange={handleInputChange}
//                       placeholder="https://"
//                     />
//                   </div>

//                   {/* Detailed Information
//                   <div className="col-md-12 mb-3">
//                     <label className="form-label">Summary</label>
//                     <textarea
//                       className="form-control"
//                       name="summary"
//                       value={formData.summary}
//                       onChange={handleInputChange}
//                       rows="3"
//                       placeholder="Enter a brief summary..."
//                     />
//                   </div>

//                   <div className="col-md-12 mb-3">
//                     <label className="form-label">Bio</label>
//                     <textarea
//                       className="form-control"
//                       name="bio"
//                       value={formData.bio}
//                       onChange={handleInputChange}
//                       rows="3"
//                       placeholder="Enter biographical information..."
//                     />
//                   </div>

//                   <div className="col-md-12 mb-3">
//                     <label className="form-label">CV and Specialization</label>
//                     <textarea
//                       className="form-control"
//                       name="cv_and_specialization"
//                       value={formData.cv_and_specialization}
//                       onChange={handleInputChange}
//                       rows="3"
//                     />
//                   </div>

//                   <div className="col-md-12 mb-3">
//                     <label className="form-label">Teaching and Research</label>
//                     <textarea
//                       className="form-control"
//                       name="teaching_and_research"
//                       value={formData.teaching_and_research}
//                       onChange={handleInputChange}
//                       rows="3"
//                     />
//                   </div>

//                   <div className="col-md-12 mb-3">
//                     <label className="form-label">Academics</label>
//                     <textarea
//                       className="form-control"
//                       name="academics"
//                       value={formData.academics}
//                       onChange={handleInputChange}
//                       rows="3"
//                     />
//                   </div>

//                   <div className="col-md-12 mb-3">
//                     <label className="form-label">Others</label>
//                     <textarea
//                       className="form-control"
//                       name="others"
//                       value={formData.others}
//                       onChange={handleInputChange}
//                       rows="3"
//                     />
//                   </div> */}
//                 </div>
//               </div>
//             </div>

//             {/* Checkboxes */}
//             {/* <div className="row mt-3">
//               <div className="col-md-4">
//                 <div className="form-check">
//                   <input
//                     type="checkbox"
//                     className="form-check-input"
//                     name="show_in_display"
//                     checked={formData.show_in_display}
//                     onChange={handleInputChange}
//                     id="show_in_display"
//                   />
//                   <label className="form-check-label" htmlFor="show_in_display">
//                     Show in Display
//                   </label>
//                 </div>
//               </div>
//               <div className="col-md-4">
//                 <div className="form-check">
//                   <input
//                     type="checkbox"
//                     className="form-check-input"
//                     name="isretired"
//                     checked={formData.isretired}
//                     onChange={handleInputChange}
//                     id="isretired"
//                   />
//                   <label className="form-check-label" htmlFor="isretired">
//                     Is Retired
//                   </label>
//                 </div>
//               </div>
//             </div> */}

//             <div className="d-flex gap-2 justify-content-end mt-3">
//               <button
//                 type="button"
//                 className="btn btn-secondary"
//                 onClick={() => navigate('/')}
//               >
//                 Cancel
//               </button>
//               <button
//                 type="submit"
//                 className="btn btn-primary"
//                 disabled={isLoading}
//               >
//                 {isLoading ? (
//                   <>
//                     <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
//                     Saving...
//                   </>
//                 ) : (
//                   'Save Profile'
//                 )}
//               </button>
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ProfileForm;

import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { Base_Url } from '../config';

const ProfileForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const isEditing = !!id;

  const [formData, setFormData] = useState({
    name: '',
    userid: '',
    designation: '',
    summary: '',
    bio: '',
    cv_and_specialization: '',
    teaching_and_research: '',
    others: '',
    academics: '',
    weblink: '',
    email: '',
    phone: '',
    image: null,
    order: '0'
  });
  const [imagePreview, setImagePreview] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const fetchProfile = useCallback(async () => {
    try {
      const response = await axios.get(`${Base_Url}/profile/${id}`);
      const profileData = response.data;
      setFormData({
        name: profileData.name || '',
        userid: profileData.userid || '',
        designation: profileData.designation || '',
        summary: profileData.summary || '',
        bio: profileData.bio || '',
        cv_and_specialization: profileData.cv_and_specialization || '',
        teaching_and_research: profileData.teaching_and_research || '',
        others: profileData.others || '',
        academics: profileData.academics || '',
        weblink: profileData.weblink || '',
        email: profileData.email || '',
        phone: profileData.phone || '',
        order: profileData.order || '0'
      });
      if (profileData.image_path) {
        setImagePreview(`${Base_Url}/${profileData.image_path}`);
      }
    } catch (error) {
      console.error('Error fetching profile:', error);
      alert('Error loading profile data');
    }
  }, [id]);

  useEffect(() => {
    if (isEditing) {
      fetchProfile();
    }
  }, [isEditing, fetchProfile]); 

  const handleInputChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    
    if (type === 'file') {
      setFormData(prev => ({ ...prev, image: files[0] }));
      setImagePreview(URL.createObjectURL(files[0]));
    } else if (type === 'checkbox') {
      setFormData(prev => ({ ...prev, [name]: checked }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const formDataToSend = new FormData();
      Object.keys(formData).forEach(key => {
        if (key === 'image' && formData[key]) {
          formDataToSend.append('image', formData[key]);
        } else {
          formDataToSend.append(key, formData[key]);
        }
      });

      if (isEditing) {
        await axios.put(`${Base_Url}/profile/${id}`, formDataToSend, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
      } else {
        await axios.post(`${Base_Url}/profile`, formDataToSend, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
      }

      navigate('/');
    } catch (error) {
      console.error('Error saving profile:', error);
      alert('Error saving profile. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container mt-4">
      <div className="card">
        <div className="card-header bg-white">
          <div className="d-flex justify-content-between align-items-center">
            <h5 className="card-title mb-0">
              {isEditing ? 'Edit Profile' : 'Add New Profile'}
            </h5>
          </div>
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="row">
              {/* Image Upload Section */}
              <div className="col-md-3 mb-3">
                <div className="text-center">
                  <div className="mb-3">
                    {(imagePreview || formData.image) && (
                      <img
                        src={imagePreview}
                        alt="Profile Preview"
                        className="rounded-circle mb-3"
                        style={{ width: '150px', height: '150px', objectFit: 'cover' }}
                      />
                    )}
                  </div>
                  <div className="mb-3">
                    <label className="btn btn-outline-primary btn-sm">
                      Choose Image
                      <input
                        type="file"
                        className="d-none"
                        name="image"
                        onChange={handleInputChange}
                        accept="image/*"
                      />
                    </label>
                  </div>
                </div>
              </div>

              {/* Form Fields Section */}
              <div className="col-md-9">
                <div className="row">
                  {/* Basic Information */}
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      required
                    />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label className="form-label">User ID</label>
                    <input
                      type="text"
                      className="form-control"
                      name="userid"
                      value={formData.userid}
                      onChange={handleInputChange}
                      required
                    />
                  </div>

                  <div className="col-md-12 mb-3">
                    <label className="form-label">Designation</label>
                    <input
                      type="text"
                      className="form-control"
                      name="designation"
                      value={formData.designation}
                      onChange={handleInputChange}
                      required
                    />
                  </div>

                  {/* Contact Information */}
                  <div className="col-md-4 mb-3">
                    <label className="form-label">Email</label>
                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="col-md-4 mb-3">
                    <label className="form-label">Phone</label>
                    <input
                      type="tel"
                      className="form-control"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="col-md-4 mb-3">
                    <label className="form-label">Website</label>
                    <input
                      type="url"
                      className="form-control"
                      name="weblink"
                      value={formData.weblink}
                      onChange={handleInputChange}
                      placeholder="https://"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="d-flex gap-2 justify-content-end mt-3">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => navigate('/')}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Saving...
                  </>
                ) : (
                  'Save Profile'
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ProfileForm;